import { useShallow } from 'zustand/react/shallow';
import type { SunrunShopState } from '@/data-store/zustand/slices/sunrunShopSlice';
import { useAppStore } from '@/data-store/zustand/zustandStoreProvider';

// https://stackoverflow.com/questions/68609189/fetching-multiple-states-with-zustand-react-shorthand-syntax
const useSunrunShopStore = <
  T extends SunrunShopState,
  K extends keyof SunrunShopState,
>(
  ...items: K[]
): Pick<T, K> => {
  const selectedItems = useAppStore(
    useShallow((state) =>
      items.reduce(
        // biome-ignore lint/performance/noAccumulatingSpread: Automated migration to Biome
        (acc, item) => ({ ...acc, [item]: state.sunrunShop[item] }),
        {}
      )
    )
  );
  return selectedItems as Pick<T, K>;
};

export const useSunrunShopActions = () =>
  useAppStore((state) => state.sunrunShop.actions);

export default useSunrunShopStore;
